import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Hero.css';

const screenshots = [
  '/screenshots/calorie-tracking.png',
  '/screenshots/boodschappen.png',
  '/screenshots/workout.png',
  '/screenshots/feed.png',
  '/screenshots/profiel.png',
];

const Hero = () => {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % screenshots.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero">
      <div className="hero__background">
        <div className="hero__shape hero__shape--1"></div>
        <div className="hero__shape hero__shape--2"></div>
        <div className="hero__shape hero__shape--3"></div>
      </div>

      <div className="hero__container">
        <div className="hero__badge">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 1L10.163 5.279L15 6.056L11.5 9.471L12.326 14.25L8 12L3.674 14.25L4.5 9.471L1 6.056L5.837 5.279L8 1Z" fill="currentColor"/>
          </svg>
          <span>{t('hero.badge')}</span>
        </div>

        <h1 className="hero__title">
          {t('hero.title')} <span className="hero__title-highlight">{t('hero.titleHighlight')}</span> {t('hero.titleEnd')}
        </h1>

        <p className="hero__subtitle">
          {t('hero.subtitle')}
        </p>

        <div className="hero__actions">
          <a href="#download" className="hero__cta hero__cta--primary">
            {t('hero.startFree')}
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.167 10h11.666M10 4.167L15.833 10 10 15.833" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
          <a href="#features" className="hero__cta hero__cta--secondary">
            {t('hero.viewFeatures')}
          </a>
        </div>

        <div className="hero__stats">
          <div className="hero__stat">
            <span className="hero__stat-number">50K+</span>
            <span className="hero__stat-label">{t('hero.activeUsers')}</span>
          </div>
          <div className="hero__stat-divider"></div>
          <div className="hero__stat">
            <span className="hero__stat-number">14M+</span>
            <span className="hero__stat-label">{t('hero.products')}</span>
          </div>
          <div className="hero__stat-divider"></div>
          <div className="hero__stat">
            <span className="hero__stat-number">1M+</span>
            <span className="hero__stat-label">{t('hero.workouts')}</span>
          </div>
        </div>
      </div>

      <div className="hero__visual">
        <div className="hero__phone">
          <div className="hero__phone-screen">
            {screenshots.map((src, index) => (
              <img
                key={src}
                src={src}
                alt={`BalanzFit scherm ${index + 1}`}
                className={`hero__screenshot ${index === currentSlide ? 'hero__screenshot--active' : ''}`}
              />
            ))}
          </div>
          <div className="hero__phone-dots">
            {screenshots.map((_, index) => (
              <button
                key={index}
                className={`hero__phone-dot ${index === currentSlide ? 'hero__phone-dot--active' : ''}`}
                onClick={() => setCurrentSlide(index)}
                aria-label={`Scherm ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
